import { Button } from '@optools/components/ui/button';
import { Calendar } from '@optools/components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@optools/components/ui/popover';
import { cn } from '@optools/components/ui/utils';
import { formatYearMonthDay } from '@optools/utils/datetime';
import { CalendarIcon } from 'lucide-react';
import { ReactNode, useState } from 'react';
import { DateRange } from 'react-day-picker';

export interface DatePickerProps {
  className?: string;
  dateRange: DateRange | undefined;
  disabled?: boolean;
  id?: string;
  onSelect: (dateRange: DateRange | undefined) => void;
  placeholder?: ReactNode;
  required?: boolean | undefined;
}

export function DateRangePicker({
  className,
  dateRange,
  disabled = false,
  id,
  onSelect,
  placeholder,
}: DatePickerProps) {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  return (
    <Popover open={isCalendarOpen} onOpenChange={setIsCalendarOpen}>
      <PopoverTrigger asChild>
        <Button
          aria-label="date calendar"
          className={cn('justify-start font-normal', className)}
          disabled={disabled}
          id={id}
          variant="outline">
          <CalendarIcon />
          <div className="flex gap-2">
            {dateRange?.from && dateRange?.to ? (
              <span>
                {formatYearMonthDay(dateRange?.from)}
                {' - '}
                {formatYearMonthDay(dateRange?.to)}
              </span>
            ) : (
              (placeholder ?? <span>Date Range</span>)
            )}
          </div>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <Calendar
          defaultMonth={dateRange?.from}
          min={0}
          mode="range"
          numberOfMonths={2}
          required={false}
          selected={dateRange}
          onSelect={(value) => onSelect(value)}
        />
      </PopoverContent>
    </Popover>
  );
}
